import { useAutoApply } from 'builder/views/AutoApply/hooks/useAutoApply'
import Icon24 from 'builder/components/Icon'
import Tooltip from 'builder/components/Tooltip'
import { useI18n } from 'builder/hooks/useI18n'
import { useUser } from 'builder/hooks/useUser'
import { useJobSearch } from '../useJobSearch'
import { TabType } from '../types'
import { JobLocationType, JobEmploymentType } from '../JobSearchResult/types'
import { Container, FilterButton, ClearButton, ChildrenContainer } from './styles'
import PostedDate from './PostedDate'
import Distance from './Distance'
import { DEFAULT_FILTERS } from './constants'
import LocationType from './LocationType'
import JobType from './JobType'

interface Props {
  children: React.ReactNode
}

export const JobFilters = ({ children }: Props) => {
  const user = useUser()
  const { isAutoApplyFeatureEnabled } = useAutoApply()

  const isFreePlan = !user?.hasPremiumFeatures

  const { i18n } = useI18n()
  const { filters, setFilters, selectedTabId } = useJobSearch()

  const clearFilters = () => {
    setFilters(DEFAULT_FILTERS)
  }

  const handleAutoApplyFilterToggle = () => {
    setFilters(prevFilters => ({
      ...prevFilters,
      onlyAutoApplyJobs: !filters.onlyAutoApplyJobs,
    }))
  }

  return (
    <Container>
      <ClearButton onClick={clearFilters}>
        <Icon24.Close />
      </ClearButton>

      <LocationType
        selected={filters.jobLocationType || ''}
        onSelect={(jobLocationType: string) =>
          setFilters(prevFilters => ({
            ...prevFilters,
            jobLocationType: jobLocationType as JobLocationType,
          }))
        }
      />
      <JobType
        selected={filters.jobType || ''}
        onSelect={(jobType: string) =>
          setFilters(prevFilters => ({
            ...prevFilters,
            jobType: jobType as JobEmploymentType | null,
          }))
        }
      />
      {isAutoApplyFeatureEnabled && !isFreePlan && (
        <Tooltip
          position="bottom"
          multiline={true}
          value={i18n.t('builder.job_search.filters.tooltips.auto_apply')}
        >
          <FilterButton selected={filters.onlyAutoApplyJobs} onClick={handleAutoApplyFilterToggle}>
            {i18n.t('builder.job_search.filters.titles.auto_apply')}
          </FilterButton>
        </Tooltip>
      )}
      <PostedDate
        selected={filters.postedWithinDays}
        onSelect={(postedWithinDays: number) =>
          setFilters(prevFilters => ({ ...prevFilters, postedWithinDays }))
        }
      />

      {selectedTabId === TabType.search && (
        <Distance
          selected={filters.radius}
          onSelect={(radius: number) => setFilters(prevFilters => ({ ...prevFilters, radius }))}
        />
      )}
      <ChildrenContainer>{children}</ChildrenContainer>
    </Container>
  )
}
